import type { FathomStore } from "@fathom/store";
import type { ReportConfig } from "./types.js";
import { collectReportData } from "./collector.js";
import { generateMarkdownReport } from "./generators/markdown.js";
import { generateHtmlReport } from "./generators/html.js";
import { generateJsonReport } from "./generators/json.js";

export type { ReportConfig, ReportData } from "./types.js";
export { collectReportData } from "./collector.js";
export { generateMarkdownReport } from "./generators/markdown.js";
export { generateHtmlReport } from "./generators/html.js";
export { generateJsonReport } from "./generators/json.js";

/**
 * Generate a complete report: collect data from store, then format.
 */
export async function generateReport(
  store: FathomStore,
  config: ReportConfig,
): Promise<string> {
  const data = await collectReportData(store, config);

  switch (config.format) {
    case "markdown":
      return generateMarkdownReport(data, config);
    case "html":
      return generateHtmlReport(data, config);
    case "json":
      return generateJsonReport(data);
    default:
      throw new Error(`Unknown report format: ${config.format}`);
  }
}
